import React from "react";
import { useTranslation } from "react-i18next";
import { MILESTONE_ICON_PATHS } from "./MilestoneKindIcon";

// Static color-key for the 3 milestone kinds (event/bodyWeight-goal/
// personalRecord) - goes in Milestones' PlannerTitleRow.subtitle slot
// instead of the "N phases" count Training/Nutrition/Tracked Results show
// there, since a milestone count alone wouldn't say anything about the mix.
// Icons come from MilestoneKindIcon.js (shared with the per-row icon in
// MilestoneRowHeader.js) - only the translation labels are specific to this
// legend.
const LEGEND_ITEMS = [
  { key: "events", translationKey: "annualPlanner.events" },
  { key: "goals", translationKey: "annualPlanner.goalsSectionTitle" },
  { key: "personalRecords", translationKey: "metrics.personalRecords" },
];

// Colors are hardcoded in CSS (.milestone-legend-item.<key>), not here - see
// annual-planner.css.
export const MilestoneLegend = () => {
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="milestone-legend">
      {LEGEND_ITEMS.map(({ key, translationKey }) => (
        <span key={key} className={`milestone-legend-item ${key}`}>
          <svg
            className="milestone-legend-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            {MILESTONE_ICON_PATHS[key]}
          </svg>
          {t(translationKey)}
        </span>
      ))}
    </div>
  );
};
